export const COST_PER_CALL = 0.15;
export const MIN_CALLS = 100;

export const TIMEZONE_OPTIONS = [
  { value: "America/New_York", label: "Eastern (ET)" },
  { value: "America/Chicago", label: "Central (CT)" },
  { value: "America/Denver", label: "Mountain (MT)" },
  { value: "America/Los_Angeles", label: "Pacific (PT)" },
  { value: "America/Anchorage", label: "Alaska (AKT)" },
  { value: "Pacific/Honolulu", label: "Hawaii (HT)" },
];

export const STATUS_CONFIG = {
  draft: {
    label: "Draft",
    color: "#1e293b",
    bgColor: "#f1f5f9",
    icon: "file-edit-outline",
  },
  pending_payment: {
    label: "Pending Payment",
    color: "#1e293b",
    bgColor: "#f1f5f9",
    icon: "credit-card-clock-outline",
  },
  active: {
    label: "Active",
    color: "#1e293b",
    bgColor: "#f1f5f9",
    icon: "check-circle",
  },
  paused: {
    label: "Paused",
    color: "#3730a3",
    bgColor: "#e0e7ff",
    icon: "pause-circle",
  },
  completed: {
    label: "Completed",
    color: "#1e40af",
    bgColor: "#dbeafe",
    icon: "check-all",
  },
  cancelled: {
    label: "Cancelled",
    color: "#991b1b",
    bgColor: "#fee2e2",
    icon: "close-circle",
  },
};

export const OUTCOME_CONFIG = {
  made_contact: { label: "Made Contact", color: "#047857", icon: "check-circle" },
  left_voicemail: { label: "Voicemail", color: "#1D4ED8", icon: "voicemail" },
  no_answer: { label: "No Answer", color: "#B45309", icon: "phone-missed" },
};
